import { Navigate } from "react-router-dom";
import type { ReactNode } from "react";
import { useAcceptPendingInvitation } from "@/features/auth/useAcceptPendingInvitation";
import { useMyMembership } from "./useMyMembership";

export function RequireOrganization({ children }: { children: ReactNode }) {
  const { data: membership, isLoading, isError } = useMyMembership();
  // Un invité arrive ici sans membership : son invitation est acceptée en
  // arrière-plan. Rediriger vers /onboarding avant le verdict lui afficherait
  // « Donnez un nom à votre espace » alors qu'il rejoint une org existante.
  const { isSettling } = useAcceptPendingInvitation();

  // On n'attend le verdict de l'invitation QUE si l'utilisateur n'a pas encore
  // de membership — c'est le seul cas où il peut changer la décision. Bloquer
  // aussi les membres établis retarderait le premier rendu de toute
  // l'application d'un aller-retour RPC, à chaque chargement de page, pour la
  // quasi-totalité des utilisateurs.
  if (isLoading || (isSettling && !membership)) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <p className="text-sm text-subtle-foreground">
          Chargement de l'organisation…
        </p>
      </div>
    );
  }

  if (isError) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <p className="text-sm text-danger">
          Erreur de chargement. Recharge la page.
        </p>
      </div>
    );
  }

  if (!membership) {
    return <Navigate to="/onboarding" replace />;
  }

  return <>{children}</>;
}
